import Trans from 'next-translate/Trans'
import React from 'react'
import useSession from 'tennders-auth/hooks/useSession'
import { GInputFile } from 'tennders-common/form/components'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

const AddDocument = ({ id, type, addDoc }) => {
  const { refreshTransaction } = useTransactions()
  const { isCarrier, isShipper } = useSession()
  const getType = () => {
    if (type) {
      return type
    }
    return isCarrier() ? 'carrier' : isShipper() ? 'shipper' : null
  }
  return (
    <GInputFile
      buttonClass="mt-20 file-upload"
      next={(file) => {
        if (addDoc) {
          addDoc(file)
        } else {
          refreshTransaction(id)
        }
      }}
      url="/documents"
      params={{
        transaction: id,
        type: getType()
      }}
    >
      <div className="file-upload__input" />
      <div className="file-upload__label">
        <FontAwesomeIcon icon={faPlus} className="mr-4" />
        <Trans i18nKey="transaction:addNewDocument" />
      </div>
    </GInputFile>
  )
}

export default AddDocument
